<div class="table-container">
  <table>
    <tbody>
      <tr>
        <td *ngFor="let head of items[0] | keys">{{head}}</td>
      </tr>
    </tbody>
    <tbody>
      <tr *ngFor="let item of items">
        <td *ngFor="let list of item | keys">{{item[list]}}</td>
      </tr>
    </tbody>
  </table>
</div>
